import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGET_groupCourseSessionPrevQuery, useGET_groupCourseSessionNextQuery } from 'redux/api/sessionsApi'
import { ISessionItem } from 'types'


interface IProps{
  sessions: ISessionItem[]
  print?: boolean
}

const SectionSubjectLessons: FC<IProps> = ({sessions, print=false}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data: prevSession } = useGET_groupCourseSessionPrevQuery(sessions.length>0 ? sessions[0].id : 0)
  const { data: nextSession } = useGET_groupCourseSessionNextQuery(sessions.length>0 ? sessions[sessions.length-1].id : 0)

  const renderSession = (s,type) => <div key={s.id} style={{ boxShadow: 'none' }} 
    className={`time-box ${type==="now" && 'selected'}`}
    onClick={() => navigate(`/sessions/view/${s.id}`)}
  >
    <div style={{ fontSize: '24px', marginBottom: '20px' }}>
      <div>{type=="now" ? t('dashboard.now') :
            type=="prev" ? t('dashboard.previous') : 
            type=="next" ? t('dashboard.next') : ""
            }</div>
    </div>

    <div className="time-box-title">
      <b>{t('goalbank.lesson')} {s.plan?.number}: </b>
      {s.plan?.title}
    </div>

    <div className="time-box-title">
        <b>{t('common.lesson-objectives')}:</b><br />
        { s.plan?.learning_objectives?.substring(0,50) }...
    </div>

  </div>

  return (
     <div>
        {print && <div>
          {sessions && sessions.filter(s => !!s.plan?.id)
              .map(s =>
                <div style={{ paddingLeft: '20px', borderTop: '1px solid #ccc', paddingTop: '10px', marginTop: '10px'}}>
                    <div style={{marginBottom: '10px'}}>
                      <b>{t('goalbank.lesson')} {s.plan?.number}</b><br />
                      {s.plan?.title}
                    </div>
                    <div>
                      <b>{t('common.lesson-objectives')}:</b><br />
                      { s.plan?.learning_objectives.substring(0,50) }...
                    </div>
                </div>)
              }

          </div>}

        {!print && <div className="workspace-tabs-box" style={{ 
            border: '2px solid #FFB800', 
            borderRadius: '20px', 
            background: '#fff', 
            padding: '20px' }}>
          <div className='timeline'>
            
            {prevSession && renderSession(prevSession, "prev")}

            {sessions && sessions
              .filter(s => !!s.plan?.id)
              .map(s => renderSession(s, "now"))
              }

             {nextSession && renderSession(nextSession, "next")}

          </div>
        </div>}

     </div>
  )
}

export default SectionSubjectLessons
